import { ArrowDownRight, ArrowUpRight } from 'lucide-react';
import styles from './StatCard.module.css';

/**
 * @param {number|null|undefined} delta — when showDelta, null/undefined renders "—"
 * @param {boolean} showDelta — keep compare chip visible even when pct is null
 */
export default function StatCard({
  icon: Icon,
  label,
  value,
  delta,
  deltaLabel,
  showDelta = false,
  tint = '#F2B922',
  sublabel,
}) {
  const hasNumber = typeof delta === 'number' && !Number.isNaN(delta);
  const trendUp = hasNumber ? delta >= 0 : null;

  return (
    <div
      className={styles.card}
      style={{
        borderLeftColor: tint,
        backgroundImage: `linear-gradient(135deg, ${tint}14, transparent 55%)`,
      }}
    >
      <Icon className={styles.watermark} style={{ color: tint }} size={62} strokeWidth={1.5} />

      <span className={styles.iconTile} style={{ background: `${tint}1f`, color: tint }}>
        <Icon size={17} strokeWidth={2.25} />
      </span>

      <div className={styles.body}>
        <div className={styles.valueRow}>
          <span className={styles.value}>{value}</span>
          {showDelta &&
            (hasNumber ? (
              <span
                className={`${styles.delta} ${trendUp ? styles.up : styles.down}`}
                title={deltaLabel}
              >
                {trendUp ? <ArrowUpRight size={11} /> : <ArrowDownRight size={11} />}
                {Math.abs(delta)}%
              </span>
            ) : (
              <span className={`${styles.delta} ${styles.deltaNull}`} title={deltaLabel || 'No previous data'}>
                —
              </span>
            ))}
        </div>
        <div className={styles.label}>{label}</div>
        {sublabel && <div className={styles.sublabel}>{sublabel}</div>}
      </div>
    </div>
  );
}
